import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    addSettingRequest: ['response'],
    addSettingSuccess: ['response', 'loading'],
    addSettingFailure: ['error'],
})

export const addSettingTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const addSettingRequest = state => state.merge({ loading: true })

const addSettingSuccess = (state, { response }) =>
    state.merge({
        error: false,
        loading: false,
        response,
    })

const addSettingFailure = (state, { error }) => {
    const { response } = error
    return state.merge({
        loading: false,
        error: true,
        response,
    })
}

export const reducer = createReducer(INITIAL_STATE, {
    [Types.ADD_SETTING_REQUEST]: addSettingRequest,
    [Types.ADD_SETTING_SUCCESS]: addSettingSuccess,
    [Types.ADD_SETTING_FAILURE]: addSettingFailure,
})
